<template>
  <div class="first-step">
    <div class="left-step">
      <span class="left-title">1</span>
      <span class="left-line"></span>
    </div>
    <div class="right-step">
      <h4>第一步：输入学号，绑定个人资料</h4>
      <div class="form-info">
        <el-form
        	ref="login"
        	:model="form"
        	label-width="0"
        	@keydown.enter.native="submit"
        >
        	<el-form-item prop="studentNo">
            你的学号
        		<el-input
        		  v-model="form.studentNo"
        		  placeholder=""
        		  type="text"
        		  clearable
        		></el-input>
        	</el-form-item>
          <el-form-item prop="activation">
            贵校的激活码
            <el-input
              v-model="form.activation"
              placeholder=""
              type="text"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button
      	type="success"
      	@click="submit"
      	class="btn-success"
      >提交</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Form, FormItem, Select, Option } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'FirstStep',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  data() {
    return {
      form: {
        studentNo:'',
        activation: ''
      },
    }
  },
  methods: {
    submit() {
        if (this.form.studentNo)
          this.login()
        else{
          this.$store.commit('showMessage', {
            message: '学号不能为空' ,
            type: 'error'
          })
        }
    },
    login() {
      const options = {
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded'},
        data:qs.stringify({openId: this.shengyaUser.openid,studentNo: this.form.studentNo}),
        url:'/cob/getStudentByNo.do'
      }
      axios(options)
      .then( (res) => {
        res = res.data
        if (res.result.success) {
          this.$emit("listenToChildEvent",res.data)
        }
        else{
          this.$store.commit('showMessage', {
            message:res.result.message,
            type: 'error'
          })
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  .first-step
    margin:0 0.3rem
    padding-top:0.3rem
    overflow:hidden
    .left-step
      float:left
      .left-title
        color:#5cb85c
        width:22px
        heihgt:20px
        display:block
        text-align:center
        border:1px solid #5cb85c
        border-radius:50%
      .left-line
        width:1px
        height:250px
        display:block
        margin-left:12px
        background-color:#5cb85c
    .right-step
      float:left
      margin-left:5px
      width:90%
      h4
        margin-bottom:0.2rem
      .form-info
        background-color:#ffffff
        border:1px solid #BBBBBB
        padding:0.2rem
        .el-form-item
          margin-bottom:5px
          /deep/ .el-form-item__content
            line-height:30px
      .btn-success
        width:50%
        margin:5% 25%
</style>
